import React from 'react';
import Flip from 'react-reveal/Flip';
import DownloadIcon from '@mui/icons-material/Download';
import {Button} from "@mui/material";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import {AboutMeScreen} from "./about-me-screen";
import {SkillsComponent} from "./SkillsComponent";
import {ProjectsComponent} from "./ProjectsComponent";
import {SectionHeader} from "./SectionHeader";

export const FirstScreen = () => {
    return (
        <Flip left>
            <div className='first-screen'>
                <h3 style={{color: 'wheat', marginTop: '150px'}}>I'M FROM BIHAR</h3>
                <h1 style={{color: 'white'}}>A SOFTWARE DEVELOPER</h1>
                <div className={'view-projects-and-resume-button-wrapper'}>
                    <a
                        href="https://drive.google.com/uc?export=download&id=1BVDh5-V-GN7gWQ0IHHiV9Nzb3dJLtg56"
                        download
                        style={{ textDecoration: "none" }}
                    >
                        <Button className="download-resume-button" variant="outlined">
                            <span>Download Resume</span>
                            <DownloadIcon />
                        </Button>
                    </a>

                    <Button
                        className="view-projects-button"
                        variant="outlined"
                        onClick={() => {
                            document.getElementById("projects-section")?.scrollIntoView({
                                behavior: "smooth",
                            });
                        }}
                    >
                        <span>View projects</span>
                        <FilePresentIcon />
                    </Button>

                </div>
                <AboutMeScreen/>a
                <SkillsComponent/>
                <SectionHeader sectionName={'PROJECTS'}/>
                <ProjectsComponent/>
            </div>
        </Flip>
    );
};